import { ApolloLink } from "@apollo/client";

/**
 * Nano-id header auth — used by player, operator, public-event auth modes.
 *
 * Reads the configured header name from a getter at request time (not at
 * factory time) so apps can refresh the key after login without
 * recreating the Apollo client.
 */
export type NanoIdAuthConfig = {
  /** Header name on the wire, e.g. "player-key", "operator-key", "polf-event-key" */
  header: string;
  /** Returns the current nano-id value; null/undefined skips the header */
  getKey: () => string | null | undefined;
};

export const createNanoIdAuthLink = ({ header, getKey }: NanoIdAuthConfig): ApolloLink =>
  new ApolloLink((operation, forward) => {
    const key = getKey();
    if (key) {
      operation.setContext(({ headers = {} }: { headers?: Record<string, string> }) => ({
        headers: { ...headers, [header]: key },
      }));
    }
    return forward(operation);
  });
